import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Prep = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M18.774 30.872a.867.867 0 0 1-.452-.122.904.904 0 0 1-.44-1.038l1.527-5.703h-1.746a.916.916 0 0 1-.672-1.54l7.633-8.194a.916.916 0 0 1 1.514.259c.082.187.1.397.05.595l-1.54 5.655h1.76a.916.916 0 0 1 .842.562.903.903 0 0 1-.17.977l-7.634 8.232a.966.966 0 0 1-.672.317Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M31.989 37.492H12.081a1.905 1.905 0 0 1-1.905-1.905V9.255a1.905 1.905 0 0 1 1.905-1.905H31.99a1.905 1.905 0 0 1 1.905 1.905v26.332a1.906 1.906 0 0 1-1.905 1.905ZM12.081 9.182l-.073 26.405 19.981.073a.073.073 0 0 0 .073-.073V9.255l-19.98-.073ZM4.9 35.44a1.771 1.771 0 0 1-1.722-1.49L.014 12.235a1.746 1.746 0 0 1 1.49-1.954l4.984-.709a.916.916 0 1 1 .268 1.808l-4.885.696L4.9 33.645l1.954-.281a.92.92 0 0 1 .269 1.82l-2.028.256H4.9ZM39.22 35.44h-.257l-2.052-.28a.916.916 0 0 1-.77-1.039.904.904 0 0 1 1.026-.781l1.967.28 3.078-21.544-4.886-.696a.916.916 0 0 1-.77-1.038.89.89 0 0 1 1.027-.77l4.983.709a1.734 1.734 0 0 1 1.416 1.954L40.93 33.987a1.697 1.697 0 0 1-.672 1.148c-.304.21-.668.318-1.038.305Z"
  }));
});
Prep.displayName = 'Prep';
Prep.defaultProps = {
  'aria-label': 'Prep'
};
export default Prep;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Prep.js
// module id = 3880
// module chunks = 11